import {  Box, Flex, Text,
} from '@chakra-ui/react';
import MyDiv from './identifyBanking.style';
import { ICandidateList } from '../../OnboardCandidateList/modal';

interface IdentifyBankingProps {
  identifyBanking?: ICandidateList | null;
}

const IdentifyBanking =({identifyBanking} : IdentifyBankingProps) => {

  return (
    <MyDiv>
      <Box className='cards' >
        <Box px={4} py={2}>
         <Text className='font-poppins text_xxl text_medium'>Identify & Banking</Text>
         <Flex justify='space-between' mt={4}>
         <Text className='font-poppins text_lg text_medium'>Aadhar Number</Text>
          <Text className='font-poppins text_lg text_regular'>{identifyBanking?.aadhar}</Text>
       </Flex>
       <Flex justify='space-between' mt={3}>
         <Text className='font-poppins text_lg text_medium'>PAN Number</Text>
          <Text className='font-poppins text_lg text_regular'>{identifyBanking?.pan}</Text>
       </Flex> 
       <Flex justify='space-between' mt={3}>
         <Text className='font-poppins text_lg text_medium'>UAN Number</Text>
          <Text className='font-poppins text_lg text_regular'>{identifyBanking?.uan}</Text>
       </Flex>
       <Flex justify='space-between' mt={3}>
         <Text className='font-poppins text_lg text_medium'>Bank Account Number</Text>
          <Text className='font-poppins text_lg text_regular'>{identifyBanking?.account_Number}</Text>
       </Flex>
       <Flex justify='space-between' mt={3}>
         <Text className='font-poppins text_lg text_medium'>IFSC Code</Text>
          <Text className='font-poppins text_lg text_regular'>{identifyBanking?.ifsc}</Text>
       </Flex>
       <Flex justify='space-between' mt={3}>
         <Text className='font-poppins text_lg text_medium'>Bank Name</Text>
          <Text className='font-poppins text_lg text_regular'>{identifyBanking?.bank}</Text>
       </Flex>
       <Flex justify='space-between' mt={3}>
         <Text className='font-poppins text_lg text_medium'>Branch</Text>
          <Text className='font-poppins text_lg text_regular'>{identifyBanking?.bank_Branch}</Text>
       </Flex>
       </Box>
      </Box>
    </MyDiv>
  );
};
 
export default IdentifyBanking;